import { motion } from "framer-motion";

export const PHONE = "(614) 325-1273";
export const PHONE_RAW = "6143251273";
export const EMAIL = "eric@fridaystumps.com";

export const IMAGES = {
  stump: "https://images.pexels.com/photos/38114648/pexels-photo-38114648.jpeg?auto=compress&cs=tinysrgb&w=1200",
  stumpBefore: "/images/stump-before.jpg",
  stumpAfter: "/images/stump-after.jpg",
  operator: "https://images.pexels.com/photos/30678455/pexels-photo-30678455.jpeg?auto=compress&cs=tinysrgb&w=1000",
  chips: "https://images.pexels.com/photos/7509234/pexels-photo-7509234.jpeg?auto=compress&cs=tinysrgb&w=1400",
  chipsClose: "https://images.unsplash.com/photo-1742931659660-6721406d1ba5?w=1200&q=80",
  forest: "https://images.unsplash.com/photo-1523712999610-f77fbcfc3843?w=1600&q=80",
};

export const EASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export function nextFridayLabel() {
  const d = new Date();
  const diff = (5 - d.getDay() + 7) % 7;
  const next = new Date(d);
  next.setDate(d.getDate() + diff);
  if (diff === 0) return "DISPATCH: TODAY — GRIND DAY";
  return `NEXT DISPATCH: FRI ${next
    .toLocaleDateString("en-US", { month: "short", day: "numeric" })
    .toUpperCase()}`;
}

export function flatPriceFor(width) {
  return width <= 12 ? 125 : 125 + Math.round((width - 12) * 7);
}

export function estimateMulti(widths) {
  const base = widths.reduce((sum, w) => sum + flatPriceFor(w), 0);
  const low = Math.max(125, Math.round((base * 0.9) / 5) * 5);
  const high = Math.round((base * 1.15) / 5) * 5;
  return { low, high };
}

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-[11px] sm:text-xs font-semibold tracking-[0.25em] uppercase text-amber-500">
    {children}
  </p>
);
